import React, { useEffect } from "react";
import { Tag } from "antd";

export default function StateTag({ state, ...props }) {
  switch (state) {
    case "INACTIVE":
      return (
        <Tag {...props} color="warning">
          DEAKTİF
        </Tag>
      );
    case "DELETED":
      return (
        <Tag {...props} color="red">
          SİLİNDİ
        </Tag>
      );
    default:
      return <></>;
  }
}
